/**
 * Thai Baht Text Converter & Receipt Utility Helpers
 */

export function thaiBahtText(num: number): string {
  if (isNaN(num) || num === 0) return 'ศูนย์บาทถ้วน';

  const numbers = ['', 'หนึ่ง', 'สอง', 'สาม', 'สี่', 'ห้า', 'หก', 'เจ็ด', 'แปด', 'เก้า'];
  const units = ['', 'สิบ', 'ร้อย', 'พัน', 'หมื่น', 'แสน', 'ล้าน'];

  const split = num.toFixed(2).split('.');
  const integerPart = parseInt(split[0], 10);
  const decimalPart = parseInt(split[1], 10);

  function convertGroup(n: number): string {
    let result = '';
    const digits = n.toString().split('').map(Number);
    const len = digits.length;

    for (let i = 0; i < len; i++) {
      const digit = digits[i];
      const unitPos = len - i - 1;

      if (digit !== 0) {
        if (unitPos === 1 && digit === 1) {
          result += 'สิบ';
        } else if (unitPos === 1 && digit === 2) {
          result += 'ยี่สิบ';
        } else if (unitPos === 0 && digit === 1 && len > 1 && digits[len - 2] !== 0) {
          result += 'เอ็ด';
        } else {
          result += numbers[digit] + units[unitPos];
        }
      }
    }
    return result;
  }

  let text = '';
  if (integerPart > 0) {
    if (integerPart >= 1000000) {
      const millionPart = Math.floor(integerPart / 1000000);
      const remainder = integerPart % 1000000;
      text += convertGroup(millionPart) + 'ล้าน' + (remainder > 0 ? convertGroup(remainder) : '');
    } else {
      text += convertGroup(integerPart);
    }
    text += 'บาท';
  }

  if (decimalPart === 0) {
    text += 'ถ้วน';
  } else {
    text += convertGroup(decimalPart) + 'สตางค์';
  }

  return text;
}
